var template = _.template(
    '<div id="<%= id %>" class="tooltip" role="tooltip"><div class="tooltip-arrow"></div><div class="tooltip-inner"></div></div>'
);
var ValidationBehavioursMixin = {
    setErrorState: function (error) {
        this.state.set('invalid', true);
        this.showPopover(
            { title: error, error: true }
        );
        this.$el.addClass('has-error');
    },
    clearErrorState: function () {
        this.state.set('invalid', false);
        this.hidePopover();
        this.$el.removeClass('has-error');
    },
    hidePopover: function () {
        if (this.state.get('popoverActivated')) {
            this.getTooltipTargetEl().tooltip('destroy');
            this.state.set('popoverActivated', false);
        }
    },
    getTooltipTargetEl: function () {
        return this.state.get('tooltipTargetEl') ?
            this.$el.find(this.state.get('tooltipTargetEl')) :
            this.$el;
    },
    showPopover: function (options) {
        var ttipId = 'tl-tooltip-' + this.cid;
        var that = this;
        options = _.defaults(
            options || {},
            {
                title: '',
                placement: 'right',
                error: false,
                trigger: 'manual',
                template: template({ id: ttipId })
            }
        );

        var $tooltipTargetEl = this.getTooltipTargetEl();
        $tooltipTargetEl.tooltip(options)
            .off('shown.bs.tooltip')
            .off('hidden.bs.tooltip')
            .on('hidden.bs.tooltip', function () {
                that.state.set('popoverActivated', false);
            })
            .on('shown.bs.tooltip', function () {
                that.state.set('popoverActivated', true);
                var $ttipEl = $('#' + ttipId);
                if (options.error) {
                    $ttipEl.addClass('has-error');
                }
             });
        $tooltipTargetEl.tooltip('show');
    }
};

module.exports = ValidationBehavioursMixin;



/*****************
 ** WEBPACK FOOTER
 ** ./assets/vendor/treeline-shared-components/validation-behaviours-mixin.js
 ** module id = 102
 ** module chunks = 1 2 3 4 8 9 15 18 19 20 21 24 40 53 64 66 78 81 89 93
 **/